import to from 'await-to-js'
import { GraphQLError } from 'graphql'

import { getCaseSurvey, updateCaseCpSurvey } from '../api_client_portal/leadgen'
import type { Resolvers } from '../generated/server/resolvers'
import request from '../requesters/clientPortal.ts'
import oathKeeper from '../requesters/oathKeeper.ts'

const SurveyResolver: Resolvers = {
  Query: {
    survey: async (_: unknown, { id }: { id: string }) => {
      const [error, surveys] = await to(getCaseSurvey(id))

      if (error || !surveys.questions) {
        throw new GraphQLError('Unable to find surveys', { extensions: { status: 404 } })
      }

      return surveys
    },
    clientGetVulnerabilityQuestion: async (_parent, { assessment_uuid, case: _case }) => {
      const useOathKeeper = sessionStorage.getItem('useOathKeeper')

      const requester = useOathKeeper === 'true' ? oathKeeper : request
      const response = await requester.get<ClientVulnerabilityQuestionResponse>(
        `/checks-service/vulnerability/question?case=${_case}&assessment_uuid=${assessment_uuid}`,
      )
      return response.data
    },
  },

  Mutation: {
    updateCaseCpSurvey: (_parent, { input, id }) => {
      return updateCaseCpSurvey([input], id)
    },
    clientAnswerVulnerabilityQuestion: async (_parent, input) => {
      const useOathKeeper = sessionStorage.getItem('useOathKeeper')

      const requester = useOathKeeper === 'true' ? oathKeeper : request
      const response = await requester.post<ClientVulnerabilityQuestionResponse>(
        `/checks-service/vulnerability/answer`,
        input.answer,
      )
      return response.data
    },
  },
}

export default SurveyResolver
